import FeatureLayer from "@arcgis/core/layers/FeatureLayer";

// ** found updated url by going to coast.noaa.gov and searching for Submarine Cables
const url = "https://coast.noaa.gov/arcgis/rest/services/Hosted/SubmarineCables/FeatureServer/0";

// ** found portal item by searching https://marinecadastre.gov/ and clicking on "open in ARCGIS online"
const portalId = '92482906ec41411cbe07da3d4d2a381b'

export const layer = new FeatureLayer({
  url,
  title: "Charted Submarine Cables",
  popupTemplate: {
    title: '{description}',
    content: [
      {
        type: "text",
        text: `<a href=${url}>More Info</a>`,
      },
    ],
  },
  visible: true,
  layerDescription: "NOAA Charted Submarine Cables",
  mapService: url,
  authoritiveSource: `https://marinecadastre.gov/`,
});

export const cables = {layerId: 'cables', type: 'layer', item: layer, meta: layer}
